import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { HOMES } from "../App";
import React from "react";

export function HKNavbar() {
  return (
    <Navbar fixed="top">
      <Container>
        <Navbar.Brand href="/">
          <img
            alt=""
            src="/konvent.png"
            width="25"
            height="35"
            className="d-inline-block align-top"
          />{" "}
        </Navbar.Brand>
        <Navbar.Brand href="/">
          <b>HOME KONVENT</b>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/">KONVENT</Nav.Link>
            <NavDropdown title="HOMES" id="basic-nav-dropdown">
              {HOMES.map((home: string) => (
                <NavDropdown.Item href={`/${home}`}>{home}</NavDropdown.Item>
              ))}
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
